import CloseIcon from '@/components/svgs/Close'
import WavyLogo from '@/components/svgs/WavyLogo'
import { Header } from '@/ui/core/header'
import { Screen } from '@/ui/core/screen'
import { VStack } from '@/ui/core/stack'
import { Text } from '@/ui/core/typography'
import { Link } from 'expo-router'
import { View, useWindowDimensions } from 'react-native'

const ReschedulePerioConfirmed = () => {
	const { width: windowWidth } = useWindowDimensions()
	const closeIconColor = windowWidth > 800 ? '#006A5C' : '#F8EDDF'

	return (
		<>
			<View className="absolute web:top-4 web:right-4 native:top-16 native:right-8 z-10">
				<Link href="../">
					<CloseIcon color={closeIconColor} />
				</Link>
			</View>
			<View className="flex-1 lg:flex-row flex">
				<View className="lg:h-full lg:w-1/2 h-1/4">
					<WavyLogo width="100%" height={'100%'} />
				</View>
				<Screen className="relative flex-1" preset="fixed">
					<VStack fullHeight className="lg:mt-0 mt-16">
						<VStack className="justify-center items-center px-16 lg:h-full" gap={12}>
							<Header className="text-center" variant="h1">
								You're all set!
							</Header>
							<Text className="text-pretty text-center max-w-60">
								Your Care team will reach out to you shortly.
							</Text>
						</VStack>
					</VStack>
				</Screen>
			</View>
		</>
	)
}

export { ReschedulePerioConfirmed }
